import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../actions'
import { Link } from 'react-router'
import PageHeader from './page-header'
import Loader from './loader'
import { colors,fontSizes,listItem } from '../utils/style'

class EmailsList extends React.Component {
  constructor(props) {
    super(props)
  }

  componentWillMount() {
    const { fetchEmails, user, emails } = this.props
    fetchEmails()
  }
  render() {
    const {emails, email, deleteEmail, loading, makeDefault, sendVerification} = this.props
    const userOpts = {}
    if (loading) userOpts['disabled'] = "disabled"
    return (
      <div>
      {
        emails ?
        (
          emails.length > 0 ?
          emails.map((item, index) => (
            <div key={index} style={listItem.container}>
              <div style={listItem.listHeading}>
                <span>{ item.email } { item.isVerified ? <span style={listItem.verified}>Verified</span> : <span style={listItem.unverified}>Not Verified</span>}</span>
              </div>
              <ul className="list-inline">
                {
                  !item.isVerified
                    ? <li>
                        <button
                            onClick={() => sendVerification({ email: item.email })}
                            {...userOpts}
                            style={{...listItem.btnLink,color:colors.primary}}>
                              { loading ? <Loader/> : 'Verify Email' }
                        </button>
                      </li>
                    : null
                }
                {
                  emails.length > 1 && item.email !== email
                    ?
                      <li>
                        <button
                          {...userOpts}
                          onClick={() => deleteEmail({email:item.email})}
                          style={{...listItem.btnLink,color:colors.danger}}>
                          { loading === true ? <Loader/> : 'Delete Email' }
                        </button>
                      </li>
                    : null
                }
                {
                  item.email !== email && item.isVerified
                    ?
                      <li>
                        <button
                          {...userOpts}
                          onClick={() => makeDefault({ email: item.email })}
                          style={{...listItem.btnLink,color:colors.success}}>
                          { loading === true ? <Loader/> : 'Set as Default' }
                        </button>
                      </li>
                    : null
                }
                {
                  item.email === email &&
                  <li>
                    Default. We will communicate with you using this email.
                  </li>
                }
              </ul>
            </div>
          )) :
          null
        ) :
        <Loader />
      }
      </div>
    )
  }
}

class AddEmail extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: ''
    }
  }

  submitEmail = () => {
    this.props.addEmail(this.state)
    this.setState({email:''})
  }

  changeEmail = (e) => {
    const email = e.target.value
    this.setState({email:email})
  }

  render() {
    const { loading } = this.props
    const userOpts = {}
    if (loading || this.state.email == '') userOpts['disabled'] = 'disabled'
    return (
      <div className="form-group">
        <label>Email</label>
        <div className="input-group">
          <input type='email' className='form-control' value={this.state.email} onChange={this.changeEmail} placeholder="Enter an email to add to the list"/>
          <span className="input-group-btn">
            <button
              onClick={this.submitEmail}
              {...userOpts}
              className='btn btn-success'>
                { this.props.loading === true ? <Loader/> : 'Add' }
            </button>
          </span>
        </div>
      </div>
    )
  }
}

class MultipleEmails extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const {
      redirectUriAfterLogin, loading, user, emails, email, path, addEmail,
      changeAddEmail, fetchEmails, deleteEmail, makeDefault, sendVerification
    } = this.props
    return (
      <div>
        <PageHeader title="Emails"/>
        <div className='container'>
          {
            user && user.sub || user && user.user && user.user.sub
              ?
                <div className='row'>
                  <div className='col-md-5'>
                    <AddEmail loading={loading} changeAddEmail={changeAddEmail} addEmail={addEmail}/>
                  </div>
                  <div className="col-md-7">
                    <EmailsList sendVerification={sendVerification} makeDefault={makeDefault} deleteEmail={deleteEmail} fetchEmails={fetchEmails} loading={loading} emails={emails} email={email}/>
                    { redirectUriAfterLogin ? <a className='btn btn-block btn-primary'  href={redirectUriAfterLogin}> Proceed with logging in</a> : null }
                  </div>
                </div>
              : <p>You are not logged in. Please login <Link to={'/login?redirect_uri=' + path}>here</Link>.</p>
          }
        </div>
      </div>
    )
  }
}


function mapStateToProps({ user, emailState, loading,redirectUriAfterLogin }, ownProps) {
  const { emails, email } = emailState
  const path = ownProps && ownProps.location && ownProps.location.pathname
  return {
    user,
    emails,
    email,
    path,
    loading,
    redirectUriAfterLogin
  }
}

function mapDispatchToProps(dispatch) {
  return ({
    fetchEmails: bindActionCreators(actions.fetchEmails, dispatch),
    addEmail: bindActionCreators(actions.addEmail, dispatch),
    deleteEmail: bindActionCreators(actions.deleteEmail, dispatch),
    makeDefault: bindActionCreators(actions.makeDefault, dispatch),
    sendVerification: bindActionCreators(actions.sendVerification, dispatch)
  })
}

export default connect(mapStateToProps, mapDispatchToProps)(MultipleEmails)



// WEBPACK FOOTER //
// ./src/app/components/multiple-emails.js